export default {
  sidebar: {
    switchSide: 'Seite wechseln',
    showSidebar: 'Seitenleiste anzeigen',
    hideSidebar: 'Seitenleiste ausblenden'
  }
}
